import React, { useEffect, useState } from 'react';
import { SmsIcon } from '../sms/SmsMarks';
import { fetchVoiceVerifications, getApiErrorMessage } from '../../services/smsApi';
import { VoiceVerificationNumber, VoiceVerificationState } from '../../types/models';
import { formatDateTime, formatUsd } from '../../utils/format';

const STATE_LABELS: Record<VoiceVerificationState, string> = {
  pending: 'Ожидает звонка', completed: 'Завершена', canceled: 'Отменена',
  timed_out: 'Время истекло', reported: 'Жалоба', refunded: 'Возврат', reused: 'Повтор',
  reactivated: 'Повторная активация', unknown: 'Уточняется',
};

function locationLabel(stateName: string | null, areaCode: string | null): string {
  if (stateName && areaCode) return `${stateName} · ${areaCode}`;
  return areaCode || stateName || 'любой штат и код';
}

const VoiceVerificationNumbersSection: React.FC = () => {
  const [items, setItems] = useState<VoiceVerificationNumber[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let stopped = false;
    let timer = 0;
    const load = async () => {
      try {
        const next = await fetchVoiceVerifications();
        if (!stopped) {
          setItems(next);
          setError('');
          setLoading(false);
          if (next.some((item) => item.state === 'pending')) timer = window.setTimeout(load, 5000);
        }
      } catch (loadError) {
        if (!stopped) {
          setError(getApiErrorMessage(loadError));
          setLoading(false);
          timer = window.setTimeout(load, 10_000);
        }
      }
    };
    void load();
    return () => { stopped = true; window.clearTimeout(timer); };
  }, []);

  return (
    <section className="sms-voice__numbers" aria-labelledby="my-voice-numbers-title">
      <div className="sms-longNumbers__head">
        <div><h2 id="my-voice-numbers-title">Voice verification</h2><p>Разовые номера для входящих звонков.</p></div>
        <a className="u2-btn is-secondary is-sm" href="/sms/voice-verification">Открыть Voice</a>
      </div>
      {error ? <div className="sms-inlineAlert is-error" role="alert">{error}</div> : null}
      {loading ? <div className="sms-longRent__loading" role="status">Загружаем Voice-номера…</div> : null}
      {!loading && !items.length ? <div className="sms-voice__empty"><SmsIcon name="headphones" /><span><strong>Номеров пока нет</strong><small>После покупки здесь появятся активные и завершённые Voice-проверки.</small></span></div> : null}
      {items.length ? <div className="sms-voiceMine__list">{items.map((item) => (
        <article className="sms-voiceMine__item" key={item.id}>
          <div><small>{item.service.name} · {locationLabel(item.location.stateName, item.location.areaCode)}</small><strong>{item.phoneNumber}</strong></div>
          <span className={`sms-voiceNumber__state is-${item.state}`}>{STATE_LABELS[item.state]}</span>
          <dl><div><dt>До</dt><dd>{formatDateTime(item.endsAt)}</dd></div><div><dt>Цена</dt><dd>{formatUsd(item.finalAmount)}</dd></div><div><dt>Звонков</dt><dd>{item.calls.length}</dd></div></dl>
        </article>
      ))}</div> : null}
    </section>
  );
};

export default VoiceVerificationNumbersSection;
